import { render, staticRenderFns } from "./DashboardAuditor.vue?vue&type=template&id=115af040&"
import script from "./DashboardAuditor.vue?vue&type=script&lang=js&"
export * from "./DashboardAuditor.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAuditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports